import React from "react";

const FastEasy = () => {
  return (
    <div className="fast_easy">
      <div className="fast_box">
        <h1 className="fast_title">Fast, Easy, and Secure Online Form</h1>

        <ul className="fast_content">
          <li className="fast_content_iten">Get funds on the web</li>
          <li className="fast_content_iten">Easy Online Form</li>
          <li className="fast_content_iten">Money Goes Right to Your Bank</li>
        </ul>
      </div>
    </div>
  );
};

export default FastEasy;
